module.exports = __webpack_public_path__ + "img/bgR2.ff461397.png";